import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import type { ReactElement, ReactNode } from 'react'

interface AppFooterContextValue {
  centerText: string | null
  setCenterText: (text: string | null) => void
}

const AppFooterContext = createContext<AppFooterContextValue | null>(null)

export function AppFooterProvider({ children }: { children: ReactNode }): ReactElement {
  const [centerText, setCenterText] = useState<string | null>(null)
  const value = useMemo(() => ({ centerText, setCenterText }), [centerText])
  return <AppFooterContext.Provider value={value}>{children}</AppFooterContext.Provider>
}

export function useAppFooterCenterTextValue(): string | null {
  return useContext(AppFooterContext)?.centerText ?? null
}

/** Sets the centre text of the app footer while the calling component is mounted. No-op without a provider. */
export function useAppFooterCenterText(text: string | null): void {
  const setCenterText = useContext(AppFooterContext)?.setCenterText
  useEffect(() => {
    if (!setCenterText) return undefined
    setCenterText(text)
    return () => setCenterText(null)
  }, [setCenterText, text])
}
